import { TailSpin } from 'react-loader-spinner';
import colors from '../../styles/theme/colors';
import * as S from './styles';

export function OnboardingCreditsPollingLoader() {
  return (
    <S.Wrapper role="status" aria-live="polite">
      <TailSpin
        visible
        height="40"
        width="40"
        color={colors.green.primary}
        ariaLabel="carregando"
      />
      <S.Message>Estamos preparando seu acesso...</S.Message>
    </S.Wrapper>
  );
}

export default OnboardingCreditsPollingLoader;
